/* Occasions gallery. Wide screens show the photos as a bento grid that never scrolls.
   On phones and tablets the photos form one scroll-snap track: it opens centred on the
   dominant photo, the arrow buttons appear and step one photo at a time, and the track
   becomes focusable for keyboard scrolling. Idempotent; re-runs on shopify:section:load. */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const init = (root) => {
    if (!root || root.dataset.occReady === 'true') return;
    const track = root.querySelector('[data-occ-track]');
    if (!track) return;
    root.dataset.occReady = 'true';

    const nav = root.querySelector('[data-occ-nav]');
    const prev = root.querySelector('[data-occ-prev]');
    const next = root.querySelector('[data-occ-next]');
    const shots = () => Array.from(track.querySelectorAll('.shot'));
    const maxScroll = () => track.scrollWidth - track.clientWidth;
    const overflowing = () => maxScroll() > 2;

    const centreOn = (shot, behavior = 'auto') => {
      if (!shot) return;
      const left = shot.offsetLeft + shot.offsetWidth / 2 - track.clientWidth / 2;
      track.scrollTo({ left: Math.max(0, Math.min(left, maxScroll())), behavior });
    };

    const nearestIndex = () => {
      const mid = track.scrollLeft + track.clientWidth / 2;
      let best = 0;
      let bestDist = Infinity;
      shots().forEach((shot, i) => {
        const dist = Math.abs(shot.offsetLeft + shot.offsetWidth / 2 - mid);
        if (dist < bestDist) { bestDist = dist; best = i; }
      });
      return best;
    };

    const update = () => {
      const over = overflowing();
      if (nav) nav.hidden = !over;
      if (over) track.setAttribute('tabindex', '0');
      else track.removeAttribute('tabindex');
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= maxScroll() - 2;
    };

    const step = (dir) => {
      const list = shots();
      const target = list[Math.max(0, Math.min(list.length - 1, nearestIndex() + dir))];
      centreOn(target, reduceMotion.matches ? 'auto' : 'smooth');
    };

    let frame = 0;
    const schedule = () => {
      if (frame) return;
      frame = requestAnimationFrame(() => { frame = 0; update(); });
    };

    if (overflowing()) {
      const list = shots();
      centreOn(track.querySelector('[data-occ-dominant]') || list[Math.floor(list.length / 2)]);
    }
    update();

    track.addEventListener('scroll', schedule, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(track);
    else window.addEventListener('resize', schedule);
    if (prev) prev.addEventListener('click', () => step(-1));
    if (next) next.addEventListener('click', () => step(1));

    /* theme editor: bring the selected photo into view */
    root.addEventListener('shopify:block:select', (event) => {
      const shot = event.target.closest('.shot');
      if (shot && overflowing()) centreOn(shot, 'auto');
    });
  };

  const boot = (scope) => {
    (scope || document).querySelectorAll('[data-occasions]').forEach(init);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
